import * as Redux from 'redux';
import { IActionCreator } from '../../../interfaces/IActionCreator';
import { Keys } from './types';
import { invokeApi } from '../../../networking/invoker';
import { infos } from '../../../../model/infos';

export interface IActions {
    loadInfos: (sub: string) => Promise<Array<infos>>;
    saveInfos: (sub: string, infos: infos) => Promise<infos>;
    deleteInfos: (sub: string, id: string) => Promise<boolean>;
}

// interface IProps extends IActions, StyledComponentProps, IRouterAppProps, INotificationAction, IChatActions, IContactActions, IMediaQueryProps {
//     newMessageReceived: boolean;
//     saveNotification: boolean;
//     setSaveNotification: (value: boolean) => void;
// }

export const actionCreator: IActionCreator<IActions> = (dispatch: Redux.Dispatch<any>): IActions => {
    return {
        loadInfos: (sub: string) => {

            var activeApi = "/api/Contact/" + sub + "/Infos";

            return new Promise((res, rej) => {
                dispatch({
                    type: Keys.LOADINFOS,
                    payload: invokeApi({
                        path: activeApi,
                        method: 'GET',
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        return resp;
                    })
                })
            });
        },
        saveInfos: (sub: string, infos: infos) => {
            return new Promise((res, rej) =>
                dispatch({
                    type: Keys.SAVEINFOS,
                    payload: invokeApi({
                        path: '/api/Contact/' + sub + '/Infos',
                        method: infos._id === "" ? 'POST' : 'PUT',
                        body: infos,
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        return resp;
                    }),
                })
            )
        },
        deleteInfos: (sub: string, id: string) => {
            return new Promise((res, rej) =>
                dispatch({
                    type: Keys.DELETEINFOS,
                    payload: invokeApi({
                        path: '/api/Contact/' + sub + '/Infos/' + id,
                        method: 'DELETE',
                        //body: infos,
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        return resp;
                    }),
                })
            )
        },
    }
}
